import React, { useState } from 'react';
import { XIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const photos = [{
  src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Tour/25YDrange.JPG',
  caption: '25-Yard Range',
  description: 'Outdoor pistol range with steel target setups'
}, {
  src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Tour/Appleseed.JPG',
  caption: 'Appleseed Shoot',
  description: 'Shooters on the outdoor rifle range during an Appleseed event'
}, {
  src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Tour/AppleseedFlags.JPG',
  caption: 'Appleseed Flags',
  description: 'Patriotic display during the Appleseed shooting event'
}, {
  src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Tour/ArcheryRange.JPG',
  caption: 'Archery Range',
  description: 'Beautiful outdoor 3-D archery course on the club grounds'
}, {
  src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Tour/MatchBanquet.JPG',
  caption: 'Match Banquet',
  description: 'Clubhouse set up for a match banquet and awards ceremony'
}, {
  src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Tour/MatchDeco.JPG',
  caption: 'Clubhouse Exterior',
  description: "The Fenton Lakes Sportsman's Club building"
}, {
  src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Tour/MatchScoring.JPG',
  caption: 'Match Scoring',
  description: 'Members gathering for match scoring and results'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cFPWkuVRZUjwMotc947mSo/welcome.jpg',
  caption: 'Welcome to Fenton Lakes',
  description: 'Celebrating our club and community'
}];
export function PhotoGallery() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  const openLightbox = (index: number) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);
  const prevPhoto = () => setLightboxIndex(prev => prev !== null ? (prev - 1 + photos.length) % photos.length : null);
  const nextPhoto = () => setLightboxIndex(prev => prev !== null ? (prev + 1) % photos.length : null);
  return <>
      <div className="w-full pt-12 md:pt-16" style={{
      backgroundColor: '#f8f6f0'
    }} data-id="element-2473">
        <div className="max-w-5xl mx-auto px-4 md:px-8" data-id="element-2474">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-2475">
            {photos.map((photo, index) => <button key={index} onClick={() => openLightbox(index)} className="bg-white rounded-xl overflow-hidden shadow-sm border text-left transition-all hover:shadow-lg hover:-translate-y-1 cursor-pointer group" style={{
            borderColor: '#ede9e0'
          }} data-id="element-2476">
                <div className="w-full h-56 md:h-64 overflow-hidden" data-id="element-2477">
                  <img src={photo.src} alt={photo.caption} className="block w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-2478" />
                </div>
                <div className="p-4" data-id="element-2479">
                  <h3 className="text-base font-bold uppercase" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#1e3d2f'
              }} data-id="element-2480">
                    {photo.caption}
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-2481">
                    {photo.description}
                  </p>
                </div>
              </button>)}
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
      backgroundColor: 'rgba(0,0,0,0.9)'
    }} onClick={closeLightbox} data-id="element-2482">
          <button onClick={closeLightbox} className="absolute top-4 right-4 w-10 h-10 rounded-full flex items-center justify-center text-white transition-colors hover:bg-white/20" data-id="element-2483">
            <XIcon size={24} data-id="element-2484" />
          </button>

          <button onClick={e => {
        e.stopPropagation();
        prevPhoto();
      }} className="absolute left-4 w-12 h-12 rounded-full flex items-center justify-center text-white transition-colors hover:bg-white/20" data-id="element-2485">
            <ChevronLeftIcon size={28} data-id="element-2486" />
          </button>

          <div className="max-w-4xl max-h-[85vh] relative" onClick={e => e.stopPropagation()} data-id="element-2487">
            <img src={photos[lightboxIndex].src} alt={photos[lightboxIndex].caption} className="block max-w-full max-h-[80vh] object-contain rounded-lg" data-id="element-2488" />
            <div className="text-center mt-4" data-id="element-2489">
              <h3 className="text-lg font-bold uppercase text-white" style={{
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-2490">
                {photos[lightboxIndex].caption}
              </h3>
              <p className="text-sm mt-1" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2491">
                {photos[lightboxIndex].description}
              </p>
              <p className="text-xs mt-2" style={{
            color: '#666',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2492">
                {lightboxIndex + 1} / {photos.length}
              </p>
            </div>
          </div>

          <button onClick={e => {
        e.stopPropagation();
        nextPhoto();
      }} className="absolute right-4 w-12 h-12 rounded-full flex items-center justify-center text-white transition-colors hover:bg-white/20" data-id="element-2493">
            <ChevronRightIcon size={28} data-id="element-2494" />
          </button>
        </div>}
    </>;
}